import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class UpdateAnalyticPlanRule {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(rule_id: number, params: Record<string, any>): Promise<any> {
    const args = {
      rule_id,
      params
    };
    return await this.dispatcher.dispatch('update.analytic_plan_rule', args);
  }
}
